import { useEffect, useState } from "react";
import AuthorSwiperInterface from "../../../Interfaces/AuthorSwiperInterface";
import nextArrow from "../../../Assets/Images/right_arrow.png";
import prevArrow from "../../../Assets/Images/left_arrow.png";
import { useNavigate } from "react-router-dom";
import Collection from "../../../Api/ReadCollection";
import { directus } from "../../../Api/FetchDirectus";
import { readItems } from "@directus/sdk";

const AuthorSwiper = () => {
  const navigate = useNavigate();
  const [authorList, setAuthorList] = useState<
    AuthorSwiperInterface[] | Record<string, any>[]
  >([]);
  const [index, setIndex] = useState<number>(0);
  const [current, setCurrent] = useState<number>(0);

  const fetchAuthorList: any = Collection.readCollection("Authors") || [];

  const fetchBond = async () => {
    try {
      return await directus.request(
        readItems(`Authors_Course_3`, { limit: -1 })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchTopics() {
    setAuthorList([...(await fetchAuthorList)]);
  }

  function next() {
    setCurrent(index === current ? 0 : current + 1);
  }

  function previous() {
    setCurrent(current === 0 ? index : current - 1);
  }

  async function onAuthorClick(
    item: AuthorSwiperInterface | Record<string, any>
  ) {
    let bondList = [...(await fetchBond())];

    let coursesList: string[] = [];

    bondList.forEach((bond) => {
      if (bond.Authors_id === item.id) {
        coursesList.push(bond.Course_id);
      }
    });

    window.scrollTo(0, 0);
    localStorage.setItem("author_courses", JSON.stringify(coursesList));
    navigate("/author_courses");
  }

  useEffect(() => {
    fetchTopics();
  }, []);

  useEffect(() => {
    setIndex(authorList.length - 1);
  }, [authorList]);

  return (
    <div className="swiper">
      <img
        className="arrow"
        src={prevArrow}
        alt="Предыдущий"
        onClick={() => previous()}
      />
      <div className="autorInfoBox">
        {authorList.map((item, index) => {
          if (current === index) {
            return (
              <div
                key={index}
                className="visible"
                onClick={() => onAuthorClick(item)}
              >
                <div className="authorPhotoBox">
                  <div className="authorPhotoBoxBackground"></div>
                  <img
                    className="authorPhoto"
                    src={"https://emir.gtsolifk.ru:4443/assets/" + item.photo}
                    alt=""
                  ></img>
                </div>
                <h2>{item.name}</h2>
                <div>{item.job_title}</div>
              </div>
            );
          }
          return null;
        })}
      </div>

      <img
        className="arrow"
        src={nextArrow}
        alt="Следующий"
        onClick={() => next()}
      />
    </div>
  );
};

export default AuthorSwiper;
